<template>
    <div>
        <div class="modal fade show d-block" tabindex="-1" role="dialog" @click.self="close">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" v-if="title || $slots.header">
                        <slot name="header">
                            <h5 class="modal-title">{{title }}</h5>
                            <button type="button" class="close" @click="close" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot>
                            <div v-html="html"></div>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="btn btn-secondary" @click="close">
                                Chiudi
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: ['title', 'html'],
        data() {
            return {};
        },
        methods: {
            close() {
                this.$router.back();
            }
        }
    };
</script>

